import React from 'react';
import { Helmet } from 'react-helmet-async';
import { GOOGLE_SITE_VERIFICATION } from '../config/analyticsConfig';
import { PUBLIC_SITE_ORIGIN } from '../config/siteConstants';

const SITE_ORIGIN = PUBLIC_SITE_ORIGIN.replace(/\/$/, '');

function toAbsoluteOgImage(url) {
  if (!url || typeof url !== 'string') return '';
  const t = url.trim();
  if (/^https?:\/\//i.test(t)) return t;
  const path = t.startsWith('/') ? t : `/${t}`;
  return `${SITE_ORIGIN}${path}`;
}

function toAbsolutePageUrl(pathOrUrl) {
  if (!pathOrUrl || typeof pathOrUrl !== 'string') return '';
  const t = pathOrUrl.trim();
  if (/^https?:\/\//i.test(t)) return t;
  const path = t.startsWith('/') ? t : `/${t}`;
  return `${SITE_ORIGIN}${path}`;
}

export default function SEO({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage,
  canonicalPath,
  jsonLd = null,
  robots,
}) {
  const defaultTitle = 'SATI Architects \u2014 \u0421\u0442\u0443\u0434\u0456\u044F \u0430\u0440\u0445\u0456\u0442\u0435\u043A\u0442\u0443\u0440\u0438';
  const defaultDesc = 'SATI Architects \u2014 \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0430 \u0441\u0442\u0443\u0434\u0456\u044F \u0430\u0440\u0445\u0456\u0442\u0435\u043A\u0442\u0443\u0440\u0438 \u0442\u0430 \u0434\u0438\u0437\u0430\u0439\u043D\u0443 \u0456\u043D\u0442\u0435\u0440\u2019\u0454\u0440\u0443. \u0421\u0442\u0432\u043E\u0440\u044E\u0454\u043C\u043E \u0435\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u0456 \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u0404\u0432\u0440\u043E\u043F\u0456 \u0442\u0430 \u0421\u0428\u0410. \u0410\u0432\u0442\u043E\u0440\u0441\u044C\u043A\u0438\u0439 \u043D\u0430\u0433\u043B\u044F\u0434.';
  /** When `ogImage` is omitted, use hosted logo (raster preferred via `ogImage` on pages). */
  const fallbackOgPath = '/Sati_correct_logo_2.svg';

  const t = title || defaultTitle;
  const d = description || defaultDesc;
  const imageUrl = toAbsoluteOgImage(ogImage || fallbackOgPath);
  const canonicalUrl = canonicalPath ? toAbsolutePageUrl(canonicalPath) : '';

  const jsonLdBlocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      {robots ? <meta name="robots" content={robots} /> : null}
      {GOOGLE_SITE_VERIFICATION ? (
        <meta name="google-site-verification" content={GOOGLE_SITE_VERIFICATION} />
      ) : null}
      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SATI Architects" />
      <meta property="og:title" content={ogTitle || t} />
      <meta property="og:description" content={ogDescription || d} />
      {canonicalUrl ? <meta property="og:url" content={canonicalUrl} /> : null}
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || t} />
      <meta name="twitter:description" content={ogDescription || d} />
      <meta name="twitter:image" content={imageUrl} />
      {jsonLdBlocks.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
